import React, {Component} from 'react';
import {withRouter, Link} from "react-router-dom";
import Pagination from "react-js-pagination";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Button } from "react-bootstrap";
import AmountSummary from "./child/amountSummary";
import OrderList from './child/orderList';
import {ToastsContainer, ToastsStore} from "react-toasts";
import {FaLongArrowAltLeft } from "react-icons/all";
import App from "../../App";
import { getPaginatedList } from "../../services/baseServices";
import {getFormattedDate} from "../../helper/utils";
import moment from "moment";



var startDate = moment().subtract(1, 'days');
var today = moment().subtract(1, 'days');
export class CashDeposit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderList: [],
			isLoading: true,
			activePage: 1,
			per_page: 25,
			page: 1,
			temp_params: { start_date_time:  startDate.format("YYYY-MM-DD"), end_date_time: today.format("YYYY-MM-DD") },
			query_params: { start_date_time:  startDate.format("YYYY-MM-DD"), end_date_time: today.format("YYYY-MM-DD") },
			isExporting: false,
			start_date_time:  startDate,
			end_date_time: today,
            totalCollectedAmount: 0,
            totalDepositAmount: 0,
            totalDueAmount: 0,
        };
    }

	getQueryParams = () => {
		let params = Object.assign(this.state.query_params, {per_page: this.state.per_page, page: this.state.page});
		return params;
	}

    getPaginatedCOs = (params) => {
        this.setState({...this.state, isLoading: true});
        getPaginatedList("customer_orders/reconciled", params)
            .then(res => {
                this.setState({
                    orderList: res?.data?.data?.orders,
                    isLoading: false,
                    per_page: res.headers['x-per-page'],
                    total_data: res.headers['x-total'],
                }, () => {
                });

                this.setState({
                    totalCollectedAmount:parseFloat(res?.data?.data?.total_collected_amount),
                    totalDepositAmount: parseFloat(res?.data.data?.total_deposited_amount),
                    totalDeoAmount: parseFloat(res?.data?.data?.due_amount),
                })
            })
            .catch(errMsg => {
                this.setState({...this.state, isLoading: false});
                console.log('Error Message: ', errMsg)
            })
    }
	componentDidMount() {
		this.getPaginatedCOs(this.getQueryParams());
	}

    handleOnSearch = (e) => {
		e.preventDefault();
		const tempParam = this.state.temp_params;
		console.log(tempParam)
		this.setState({...this.state, page: 1, query_params: tempParam}, () => {
			this.getPaginatedCOs(this.state.temp_params);
		});
	}
	handleOnFieldChange = (e) => {
		const queryData = {...this.state.temp_params};
		queryData[e.target.name] = e.target.value;
		this.setState({temp_params: queryData}, () => {
		});
	}

	handlePageChange = (pageNumber) => {
		this.setState({page: pageNumber, activePage: pageNumber}, () => {
		    this.getPaginatedCOs(this.getQueryParams());
		});
	}

	handleOnApply = (e, picker)=>{
		this.setState({start_date_time: getFormattedDate(picker.startDate, ''), end_date_time: getFormattedDate(picker.endDate,'')})
		this.setState({temp_params: {...this.state.temp_params, start_date_time: getFormattedDate(picker.startDate,"YYYY-MM-DD"), end_date_time: getFormattedDate(picker.endDate,"YYYY-MM-DD")}})
	}
    
    refreshData = () => {
        this.getPaginatedCOs(this.getQueryParams());
    }

    render() {
        const {totalCollectedAmount, totalDepositAmount, totalDeoAmount} = this.state;
        return (
            <App>
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">Cash Deposit</h2>
                        <div className="ml-auto">
                            <Link to={`/cash-deposit/list`}
                                className="btn btn-sm btn-link"><FaLongArrowAltLeft/> Back to List
                            </Link>
                </div>
                    </div>
                    <div className='d-flex justify-content-center'>
                        <form className="form-inline mb-3">
                            <div className="form-group mr-3">
                                <label htmlFor="status" className="sr-only">
                                    Date Range
                                </label>
                                <DateRangePicker
                                    initialSettings={{ 
                                        startDate: this.state.start_date_time,
                                        endDate: this.state.end_date_time,
                                        maxSpan:{"months": 3},
                                        showDropdowns: true,
                                        locale:{format: "DD/MM/YYYY"},
                                        autoApply: true,
                                    }}
                                    onApply={(e, picker) => this.handleOnApply(e, picker)}
                                >
                                    
                                    <input type="text"
                                        value={this.state.start_date_time && this.state.end_date_time ? 
                                            `${getFormattedDate(this.state.start_date_time,"DD/MM/YYYY")} - ${getFormattedDate(this.state.end_date_time,"DD/MM/YYYY")}` : ''}
                                        style={{textAlign: 'left', minWidth: '150px'}}
                                        placeholder={"Select date range"}
                                        className="form-control form-control-sm"/>
                                </DateRangePicker>
                            </div>
                            <Button
                                size="sm"
                                type={`submit`}
                                onClick={this.handleOnSearch}
                                variant="primary"
                            >
                                Filter
                            </Button>
					</form>
                    </div>
                    <div className="card-block">
                        <div className="block-body">
                            <AmountSummary totalCollectedAmount={totalCollectedAmount}
                                            totalDepositAmount={totalDepositAmount}
                                            totalDeoAmount={totalDeoAmount}
                                            query_params={this.state.query_params}
                                            refreshData={this.refreshData}/>
                            <hr/>
                        </div>
                        <OrderList 
                            orderList={this.state.orderList}
                            isLoading={this.state.isLoading}
                            />
                        <div className="mt-3">
                            <Pagination
                                itemClass="page-item"
                                linkClass="page-link"
                                activePage={this.state.activePage}
                                itemsCountPerPage={this.state.per_page}
                                totalItemsCount={this.state.total_data}
                                pageRangeDisplayed={10}
                                onChange={this.handlePageChange.bind(this)}
                            />
							</div>
                    </div>
                </div>
                <ToastsContainer store={ToastsStore}/>
            </App>
        )
    }
}

export default withRouter(CashDeposit);
